import { History } from 'history';
import Banner from '../Banner';
import useCalendly from '../../openCalendly';

interface Props {
  history?: History;
}

const HeroBanner = ({ history, ...rest }: Props): JSX.Element => (
  <Banner {...rest} onClick={useCalendly()}>
    <span>
      <span>
        Are you a school leader looking to learn more? <b>Book a consultation here.</b>
      </span>
    </span>
  </Banner>
);

export default HeroBanner;
